import React, { Component } from 'react';
import ProductCard from '../product/ProductCard';
import './ProductListStyles.css'


class ProductList extends Component {
    render() {
        return (
            <div className="container">
                <main className="grid">
                    {
                        this.props.prod.map((ob, key) => {
                            
                            return <ProductCard obj={ob} key={key} />
                        })
                    }
                </main>
            </div>
        );
    }
}

export default ProductList;
